module.exports = __webpack_public_path__ + "img/video01.ae563f58.jpg";